<tui-root>
  <ngx-loading-bar height="3px" [includeSpinner]="false" color="#C5CEE0"/>
  <nb-layout class="zero-padding">
    <nb-layout-column class="zero-padding">
      <router-outlet />
    </nb-layout-column>
  </nb-layout>
</tui-root>
